module.exports = __webpack_public_path__ + "static/media/swifttest_logo.d05ae22a.png";